export enum SpreadsheetStep {
  welcome = 0,
  quotations,
  companyInfo,
  download

}